/**
 * Created by user on 11/3/2015.
 */


/* Give tinyMCE textarea ids */
var tinyCounter = 0;
$('.txtTiny').each(function () {
    if (!$(this).id) {
        $(this).attr('id', 'txtTiny-' + tinyCounter);
        $(this).id = 'txtTiny-' + tinyCounter;
        tinyCounter++;
    }
});

$.fn.select2.defaults.set("theme", "bootstrap");
$.fn.select2.defaults.set("width", null);

var collectiveDataTables = [];
$(function () {
    $('#menuAccordion').find('li.header.expanded').nextUntil('.header').addClass('expanded');
    $('#menuAccordion').find('li:not(.header)').each(function () {
        if ($(this).prevAll().is('.header')) {
            return false;
        } else {
            $(this).addClass('expanded');
        }
    });
    $('#menuAccordion').find('li.header').click(function () {
        if ($(this).hasClass('expanded')) {
            $(this).nextUntil('.header').removeClass('expanded');
            $(this).removeClass('expanded');
        } else {
            $('#menuAccordion').find('li.header.expanded').click();
            $(this).addClass('expanded');
            $(this).nextUntil('.header').addClass('expanded');
        }
    });

    if(typeof datatablesData != 'undefined') {
        dataTable = $('#dataTable').dataTable(datatablesData);
        dataTableTrashed = $('#dataTableTrashed').dataTable(datatablesData);

        var hasSortOrderable = false;
        $('.collectiveDataTables').each(function () {
            var thisDatatablesData = datatablesData;

            var sortOrderable = false;
            if ($(this).hasClass('sortOrderable')) {
                hasSortOrderable = true;
                sortOrderable = true;
                $.extend(thisDatatablesData, {
                    dom: "<'row'<'col-sm-6'f><'col-sm-6'<'sortOrderButtonContainer'>l>><'row'<'col-sm-12'tr>><'row'<'col-sm-6'i><'col-sm-6'p>>"
                });
            }
            if ($(this).hasClass('tableTools')) {
                $.extend(thisDatatablesData, {
                    dom: "T<'clearfix'>" + thisDatatablesData.dom
                });
            }
            var $thisDataTable = $(this).dataTable(thisDatatablesData);
            if (sortOrderable) {
                $thisDataTable.closest('.dataTables_wrapper').find('.sortOrderButtonContainer').data('enabled', true);
            }
            collectiveDataTables.push($thisDataTable)
        });
        if (hasSortOrderable) {
            $('.dataTables_wrapper .sortOrderButtonContainer').each(function () {
                if ($(this).data('enabled')) {
                    $(this).html('<a class="btn btn-warning btn-flat btn-sm pull-right btnInitSort" data-mfp-src="#divSorts"><i class="fa fa-sort"></i> Sort Order</a>');
                }
            });

            $('#divSorts .olSortable').sortable();

            $('.btnInitSort').magnificPopup({
                type: 'inline',
                midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
                mainClass: 'mfp-fade'
            });
        }
    }

    $('.magnific-image').magnificPopup({
        type: 'image',
        gallery: {enabled: true}
    });
    $.AdminLTE.tree = function (menu) {
        var _this = this;
        var animationSpeed = $.AdminLTE.options.animationSpeed;
        $("li a", $(menu)).unbind("click");
        $("li a", $(menu)).on('click', function (e) {
            //if this isn't a link, prevent the page from being redirected
            if ($(this).attr('href') == '#') {
                //Get the clicked link and the next element
                var $this = $(this);
                var checkElement = $this.next();

                //Check if the next element is a menu and is visible
                if ((checkElement.is('.treeview-menu')) && (checkElement.is(':visible'))) {
                    //Close the menu
                    checkElement.slideUp(animationSpeed, function () {
                        checkElement.removeClass('menu-open');
                        //Fix the layout in case the sidebar stretches over the height of the window
                        //_this.layout.fix();
                    });
                    checkElement.parent("li").removeClass("active");
                }
                //If the menu is not visible
                else if ((checkElement.is('.treeview-menu')) && (!checkElement.is(':visible'))) {
                    //Get the parent menu
                    var parent = $this.parents('ul').first();
                    //Close all open menus within the parent
                    var ul = parent.find('ul:visible').slideUp(animationSpeed);
                    //Remove the menu-open class from the parent
                    ul.removeClass('menu-open');
                    //Get the parent li
                    var parent_li = $this.parent("li");

                    //Open the target menu and add the menu-open class
                    checkElement.slideDown(animationSpeed, function () {
                        //Add the class active to the parent li
                        checkElement.addClass('menu-open');
                        parent.find('li.active').removeClass('active');
                        parent_li.addClass('active');
                        //Fix the layout in case the sidebar stretches over the height of the window
                        _this.layout.fix();
                    });
                }

                e.preventDefault();
            }
        });
    };

    $.AdminLTE.tree('.sidebar');
});